import { reportKindSchema } from '@deposits-system/contracts';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import { ReportsPage } from '@/features/reports/reports-page.js';

const searchSchema = z.object({
  page: z.coerce.number().int().positive().optional().catch(undefined),
  pageSize: z.coerce.number().int().positive().max(100).optional().catch(undefined),
  from: z.iso.date().optional().catch(undefined),
  to: z.iso.date().optional().catch(undefined),
  branchId: z.string().optional().catch(undefined),
  currencyId: z.string().optional().catch(undefined),
  state: z.enum(['IN_CUSTODY', 'DELIVERED', 'RETURNED', 'CANCELLED']).optional().catch(undefined),
  employeeId: z.string().optional().catch(undefined),
  customer: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/reports/$kind')({
  validateSearch: searchSchema,
  beforeLoad: ({ params }) => {
    if (!reportKindSchema.safeParse(params.kind).success) throw notFound();
  },
  component: ReportRoute,
});

function ReportRoute(): React.JSX.Element {
  const { kind } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const parsed = reportKindSchema.parse(kind);
  return (
    <ReportsPage
      key={parsed}
      kind={parsed}
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
